var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0009 0.916016C14.6646 0.916016 18.3283 3.79463 18.3283 7.45831V11.3837C19.8984 11.3837 21.4686 12.9538 21.4686 14.7857V23.9449C21.4686 25.5151 19.8984 27.0852 18.0666 27.0852H3.6735C2.10335 27.0852 0.533203 25.5151 0.533203 23.6832V14.524C0.533203 12.9538 2.10335 11.3837 3.6735 11.3837V7.45831C3.6735 3.79463 7.33719 0.916016 11.0009 0.916016ZM11.0009 4.05632C8.90734 4.05632 7.0755 5.36478 7.0755 7.45831V11.3837H14.9263V7.45831C14.9263 5.36478 13.0944 4.05632 11.0009 4.05632Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.2e5b6b61acaf63e028b149d4928c6167.svg";
export { ForwardRef as ReactComponent };